import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputFormGroupComponent } from './inputFormGroup.component';

@NgModule({
  declarations: [
    InputFormGroupComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [
    InputFormGroupComponent,
  ],
})
export class InputFormGroupModule {}



// WEBPACK FOOTER //
// ./src/app/common/components/InputFormGroupComponent/inputFormGroup.module.ts